const t = {
  name: "PlusMultiple",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 18V15H18V13H15V10H13V13H10V15H13V18H15Z" fill="currentColor"/>
<path d="M5 2C3.34315 2 2 3.34315 2 5V15C2 16.6569 3.34315 18 5 18H6V19C6 20.6569 7.34315 22 9 22H19C20.6569 22 22 20.6569 22 19V9C22 7.34315 20.6569 6 19 6H18V5C18 3.34315 16.6569 2 15 2H5ZM16 6H9C7.34315 6 6 7.34315 6 9V16H5C4.44772 16 4 15.5523 4 15V5C4 4.44772 4.44772 4 5 4H15C15.5523 4 16 4.44772 16 5V6ZM8 19V9C8 8.44772 8.44772 8 9 8H19C19.5523 8 20 8.44772 20 9V19C20 19.5523 19.5523 20 19 20H9C8.44772 20 8 19.5523 8 19Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as PlusMultiple
};
